import * as types from '../constants/ActionTypes';

const initialState = {
  topicTreeSelectResult: undefined,
  topicsDisplay: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.SELECT_TOPIC_L1:
    case types.SELECT_TOPIC_L2:
    case types.SELECT_TOPIC_L3:
    case types.SELECT_TOPIC_RESET:
    case types.CANCEL_EMAIL_FORM_NO_INTENT:
      return { ...state, topicTreeSelectResult: undefined, topicsDisplay: true };
    case types.SELECT_RESULT:
      return { ...state, topicTreeSelectResult: action.payload, topicsDisplay: false };
    default:
      return state;
  }
}
